import { AppStore } from './../../core/state/app-store';
import { environment } from './../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { AuthService } from './../../core/auth.service';
import { AlphabeticSortTypes, SortData } from './../../models/sort.model';
import { Position } from './../../models/api/vehicle-position.model';
import { SortTypes } from '../../models/sort.model';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SortVehiclesService {
  private urlVehiclesSort = environment.baseUrl + environment.api + 'users/vehicles_sort';
  private sortTypes = [
    {
      label: 'vehicles.statistics.sort.max-speed',
      value: SortTypes.MAX_SPEED,
      order: 1
    },
    {
      label: 'vehicles.statistics.sort.avg-speed',
      value: SortTypes.AVG_SPEED,
      order: 2
    },
    {
      label: 'vehicles.statistics.sort.distance',
      value: SortTypes.DISTANCE,
      order: 3,
    },
    {
      label: 'vehicles.statistics.sort.engine-starts',
      value: SortTypes.ENGINE_STARTS,
      order: 4,
    },
    {
      label: 'vehicles.statistics.sort.ride-time',
      value: SortTypes.RIDE_TIME,
      order: 5,
    },
    {
      label: 'vehicles.statistics.sort.park-time',
      value: SortTypes.PARK_TIME,
      order: 6,
    },
  ];

  constructor(
    private authService: AuthService,
    private http: HttpClient,
    private appStore: AppStore
  ) {}

  updateSort(sortData: SortData) {
    sortData = { ...this.appStore.getState().sortData, ...sortData };
    this.appStore.setSortStateValue(sortData);
    if (!this.authService.isDSLocateUser()) {
      return this.http.post(this.urlVehiclesSort, sortData, {
        headers: this.authService.getJwtAuthHeaders(),
      });
    } else {
      localStorage.setItem('sortState', JSON.stringify(sortData));
      return of(true);
    }
  }

  getSortTypes() {
    return this.sortTypes;
  }

  public sortAlphabeticly(
    src: Position[],
    sortType: AlphabeticSortTypes
  ): Position[] {
    const sortValue = sortType === AlphabeticSortTypes.ASC ? 1 : -1;
    return src.sort((a, b) => {
      return a.name.toLowerCase() > b.name.toLowerCase()
        ? sortValue
        : -sortValue;
    });
  }

  public sortVehicles(src: Position[], sortType: SortTypes): Position[] {
    const results: Position[] = src;
    if (sortType) {
      return results
        .filter((position) => {
          return (
            new Date().toDateString() ===
            new Date(parseInt(position.time, 10) * 1000).toDateString()
          );
        })
        .sort((a, b) => {
          return this.getValue(a, sortType) > this.getValue(b, sortType)
            ? -1
            : 1;
        });
    }
    return results;
  }

  getParamByName(position: Position, paramName: SortTypes): string {
    return position.vstats.sparam.find((param) => param.name == paramName)
      .value;
  }

  getOnlyValue(valueWithUnit: string): number {
    return Number(valueWithUnit.split(' ')[0]);
  }

  getValue(position: Position, sortType: SortTypes) {
    switch (sortType) {
      case SortTypes.AVG_SPEED:
      case SortTypes.MAX_SPEED:
      case SortTypes.DISTANCE:
        return this.getOnlyValue(this.getParamByName(position, sortType));
      case SortTypes.ENGINE_STARTS:
      case SortTypes.RIDE_TIME:
      case SortTypes.PARK_TIME:
        return Number(this.getParamByName(position, sortType));
      default:
        return 0;
    }
  }
}
